var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarCopyBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 3.33325H18.91C15.97 3.33325 13.64 3.33325 11.8183 3.57992C9.94167 3.83325 8.42333 4.36659 7.22667 5.56825C6.02833 6.76992 5.49667 8.29492 5.245 10.1783C5 12.0083 5 14.3466 5 17.2983V27.0282C5 29.5416 6.53333 31.6949 8.71167 32.5983C8.6 31.0816 8.6 28.9566 8.6 27.1866V18.8366C8.6 16.7016 8.6 14.8599 8.79667 13.3866C9.00833 11.8066 9.485 10.2933 10.7083 9.06492C11.9317 7.83659 13.44 7.35825 15.0133 7.14492C16.48 6.94825 18.3133 6.94825 20.4417 6.94825H25.5583C27.685 6.94825 29.515 6.94825 30.9833 7.14492C30.5435 6.02207 29.7755 5.05782 28.7796 4.37789C27.7836 3.69797 26.6059 3.33393 25.4 3.33325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.995C11 14.4517 11 12.18 12.4067 10.7684C13.8117 9.35669 16.0733 9.35669 20.6 9.35669H25.4C29.925 9.35669 32.1883 9.35669 33.595 10.7684C35.0017 12.18 35 14.4517 35 18.995V27.0284C35 31.5717 35 33.8434 33.595 35.255C32.1883 36.6667 29.925 36.6667 25.4 36.6667H20.6C16.075 36.6667 13.8117 36.6667 12.4067 35.255C11 33.8434 11 31.5717 11 27.0284V18.995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarCopyBold);
export default __webpack_public_path__ + "static/media/solar_copy-bold.615ba2324bfd7b5dba383ccbba666d35.svg";
export { ForwardRef as ReactComponent };